<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
  	  <el-tag type="danger">温馨提示：一般用于清除前期试用时产生的无用数据，数据清除后，不可恢复，请谨慎使用</el-tag>
  	  <div class="backborder3" style="margin-top:10px">
  	  	  <div class="maincate">
  	  	  	  <span class="maintitle1" style="margin:20px 0 5px 0;">系统初始化</span>
  	  	  	  <span class="maintitle2" style="margin:0 0 5px 0;">（恢复至首次登录状态）</span>
  	  	  	  <el-button type="warning" icon="el-icon-delete" size="mini" style="margin:0 0 5px 0" @click="resetdata">清除数据</el-button>
  	  	  	  <span class="maintitle2" style="margin:0 0 20px 0;">点击按钮开始清除数据</span>
  	  	  </div>
  	  	  <div class="maincate">
  	  	  	  <span class="maintitle1" style="margin:20px 0 5px 0;">全部数据</span>
  	  	  	  <span class="maintitle2" style="margin:0 0 5px 0;">（基本档案+单据+期初）</span>
  	  	  	  <el-button type="warning" icon="el-icon-delete" size="mini" style="margin:0 0 5px 0">清除数据</el-button>
  	  	  	  <span class="maintitle2" style="margin:0 0 20px 0;">点击按钮可自定义要清除哪些数据</span>
  	  	  </div>
  	  </div>
  	  
  	  <!--------------- 重置信息发送短信 ------------------->
  	  <el-dialog title="重置数据" :visible.sync="resetDialog" width="30%" top="13%">
	      <el-form :inline="true" class="demo-form-inline" size="small">
	      	  <el-form-item style="width:100%">
	              <template><span>向手机号{{resetquery.phone}}发送验证码</span></template>
	          </el-form-item>
	          <el-form-item>
	          	  <el-input placeholder="请输入验证码" v-model="resetquery.code"></el-input>	          	  
	          </el-form-item>
	          <el-form-item>
	          	  <el-button type="primary" size="small" @click="getcode" v-if="resetquery.islock==false">{{resetquery.name}}</el-button>
	          	  <el-button type="primary" size="small" @click="getcode" v-if="resetquery.islock==true" disabled>{{resetquery.name}}</el-button>     	       	  
	          </el-form-item>
	      </el-form>
	      <div slot="footer" class="dialog-footer">
          	  <el-button size="small" @click="resetDialog = false">取 消</el-button>
          	  <el-button size="small" type="danger" @click="clearalldata" :loading="clearallLoading">执行</el-button>
      	  </div> 	                
	  </el-dialog> 
  	  
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Password/index",
      actionauth:'', //功能权限
      transitionshow:true,
      resetDialog:false,
      resetquery: {
      	  act:'getadminphone',
      	  token:this.$cookies.get('token'),
      	  name:"获取验证码",
      	  phone:'',
      	  code:'',
      	  islock:false,
      },
      interval:'',
      clearallLoading:false,
      number:60,
      
    }
  },
  
  mounted(){
      this.getactionauth();
  },
  
  methods:{
  
    /** 获取操作权限 **/
	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    /** 系统数据初始化 **/
    resetdata() {
    	this.resetquery.name="获取验证码";
    	this.resetquery.phone="";
    	this.resetquery.code="";
    	this.resetquery.islock=false;
    	clearInterval(this.interval);
    
    	this.resetDialog=true;
    	var resource = this.$resource(this.url);
        resource.query(this.resetquery).then((res) => {
        	if(res.data.Result>0){
          		if(res.data.Result=='70001') this.$router.push('/login')
          		this.$message.error(res.data.Message);
        	}else{
          		var result = JSON.parse(Base64.decode(res.data.Data));
          		this.resetquery.phone=result.phone;
        	}
        }).catch((res) => {
          	this.$message.error(this.GLOBAL.errortext);
        });	
    },  
    
    /** 获取验证码信息 **/
    getcode() {
    	var _this=this;
    	this.number=60;
    	this.resetquery.islock=true;

    	this.interval=setInterval(function(){
    		if(_this.number==0) {
	    		_this.resetquery.name="重新发送";
				_this.resetquery.islock=false;
				clearInterval(_this.interval);
				_this.number=60;
    			return false;
    		}    		
		    _this.number--;
		    _this.resetquery.name=_this.number+"秒后重新发送";
		},1000);
		this.sendcode(); //发送验证码到
    },
    
    /** 发送验证码 **/
    sendcode() {    
    	var resource = this.$resource(this.url);
        resource.query({act:'sendmsg',token:this.$cookies.get('token'),phone:this.resetquery.phone}).then((res) => {
        	if(res.data.Result>0){
          		if(res.data.Result=='70001') this.$router.push('/login')
          		this.$message.error(res.data.Message);
        	}else{
        		var result = JSON.parse(Base64.decode(res.data.Data));
          		this.resetquery.code=result.code;
        	}
        }).catch((res) => {
          	
        });	
    },
    
    /** 清除所有数据 **/
    clearalldata() {
    	this.clearallLoading=true;
    	var resource = this.$resource(this.url);
        resource.query({act:'clearalldata',token:this.$cookies.get('token'),phone:this.resetquery.phone,code:this.resetquery.code}).then((res) => {
        	if(res.data.Result>0){
          		if(res.data.Result=='70001') this.$router.push('/login')
          		this.$message.error(res.data.Message);
          		this.clearallLoading=false;
        	}else{
        		this.$message.success("系统初始化成功");
        		this.clearallLoading=false;
        		this.resetDialog=false;
        	}
        }).catch((res) => {
          	this.clearallLoading=false;
        });	
    },
     
    
  }
  
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder3 {background:#fff;border-radius:15px;border:1px solid #ddd;float:left;width:98%;padding:2% 1% 2% 1%;}
.maincate {float:left;width:35%;margin-left:10%;border:1px solid #DCDFE6;text-align:center;border-radius:5px;}
.maintitle1 {float:left;width:100%;font-weight:bold;font-size:16px}
.maintitle2 {float:left;width:100%;color:#C0C4CC;font-size:13px}
.maincate:hover {box-shadow: #C0C4CC 10px 10px 40px 3px;}
</style>


// WEBPACK FOOTER //
// src/components/config/Sysreset.vue